import {AuditType} from "../../shared/components/audit/audit.types";

export enum GeneralFieldNames{
    clinic_act_medical= "clinic_act_medical",
    clinic_investigatii_paraclinice= "clinic_investigatii_paraclinice",

    clinic_person1_name= "clinic_person1_name",
    clinic_person2_name= "clinic_person2_name",
    clinic_person3_name= "clinic_person3_name",
    clinic_person4_name= "clinic_person4_name",
    clinic_person5_name= "clinic_person5_name",
    clinic_person6_name= "clinic_person6_name",
    clinic_person7_name= "clinic_person7_name",

    clinic_person1_proffession= "clinic_person1_proffession",
    clinic_person2_proffession= "clinic_person2_proffession",
    clinic_person3_proffession= "clinic_person3_proffession",
    clinic_person4_proffession= "clinic_person4_proffession",
    clinic_person5_proffession= "clinic_person5_proffession",
    clinic_person6_proffession= "clinic_person6_proffession",
    clinic_person7_proffession= "clinic_person7_proffession",

    clinic_person1_grad= "clinic_person1_grad",
    clinic_person2_grad= "clinic_person2_grad",
    clinic_person3_grad= "clinic_person3_grad",
    clinic_person4_grad= "clinic_person4_grad",
    clinic_person5_grad= "clinic_person5_grad",
    clinic_person6_grad= "clinic_person6_grad",
    clinic_person7_grad= "clinic_person7_grad",
}


export enum InternalDocummentID{
    BASIC_INF = "BASIC_INF", // Acord pacient informat SB V2
    API_SB_V2= "API_SB_V2", // Acord pacient informat SB V2
    BUL_INFO_SB_V1 = "BUL_INFO_SB_V1", //Chestionar de evaluare a starii generale de sanatate
    GDPR_AGREE_SB_V1 = "GDPR_AGREE_SB_V1", // Formular declaratie de consimtamant GDPR
}

export class InternalDocDefinition {
    name:String;
    description:String;
    version:string;
}

export const availableDocs: Record<InternalDocummentID, InternalDocDefinition> = {
    BASIC_INF: {
        version: "Revizia 1",
        description: "Actualizarea informatiilor de baza ale pacientului",
        name: "Informatii de baza"
    },
    API_SB_V2: {
        version: "Revizia 2 / 02.12.2024 ",
        description: "Aprobat de colegiul medicilor stomatologi Sibiu",
        name: "Acordul pacientului informat"
    },
    BUL_INFO_SB_V1: {
        version: "Revizia 1",
        description: "Aprobat de colegiul medicilor stomatologi Sibiu",
        name: "Buletin informativ"
    },
    GDPR_AGREE_SB_V1: {
        version: "Revizia 1",
        description: "Aprobat de colegiul medicilor stomatologi Sibiu",
        name: "Formular declaratie de consimtamant GDPR"
    },
} as const;

export enum DocType{
    DOC = "DOC",
    PDF = "PDF",
    XLS = "XLS",
    TXT = "TXT",
    JPG = "JPG"
}

export enum NotificationType {
    MAIL = "MAIL",
    SMS = "SMS",
}

export enum DocummentAuditStatus{
    NOT_DONE = "NOT_DONE", // only on UI
    ANY = "ANY", // only on UI
    OPEN = "OPEN",
    USER_REVIEW = "USER_REVIEW",
    CLINIC_REVIEW = "CLINIC_REVIEW",
    DONE = "DONE",
    CANCELED = "CANCELED"
}


export class SMMDocumentAuditUpdate{
    notificationType: NotificationType;
    notifyUserOnCompletion: boolean;
}

export class SMMDocummentAudit extends AuditType
{
    id: string;
    userWarningId: string;                  // documment id
    userKey: string;                        // unique key user uses to fill in docs
    userCompletionTime: [];                 // timestamp patient filled doc and sent it for review
    clinicUserReviewCompletionTime: [];     // timestamp clinic accepted teh doc
    userNotificationCompletionTime: [];     // timestamp patient was notified via SMS/EMAIL about doc acceptance
    notificationType: NotificationType;
    status: DocummentAuditStatus;
    notifyUserOnCompletion: boolean;
}

export class SMMDocumment extends AuditType {
    id: string;
    userId: string;
    userWarningAuditId: string;
    legalDocumentName: string;
    legalDocumentInternalId: string;
    signature: string;
    userWarningAuditStatus: DocummentAuditStatus;
    userKey: string;

    //extra
    type       : DocType;
}

export class DocUserField {
    id: string;
    userWarningId: string;
    name: string;
    value: string;

    constructor(userWarning:string, name:string, value:string) {
        this.userWarningId = userWarning;
        this.name = name;
        this.value = value;
    }
}

export class SMMLegalDocument {
    id: string;
    displayName: string;
    internalId: string;
}

export class SMMLegalDocumentTriggerDTO{
    userId: string;
    legalDocumentId: string;
    status: DocummentAuditStatus;
}
